<i18n src="@/locales/models/delivery.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/delivery_item.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_delivery.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_deliveries')"
    :params="{
      service_provider_id: service_provider_id,
      delivery_process_id: delivery_process_id,
    }"
  />

  <bread-crumbs :labels="[module_name, delivery_process?.name]" />

  <template v-if="load_general_data">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery.delivery_code") }}
                </dt>
                <dd class="content-data">
                  {{ delivery.delivery_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery.started_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(delivery.started_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery.delivered_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(delivery.delivered_at) }}
                </dd>
              </div>

              <!-- <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery.delivery_type") }}
                </dt>
                <dd class="content-data">
                  {{ delivery.delivery_type }}
                </dd>
              </div> -->

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery.delivery_employee") }}
                </dt>
                <dd class="content-data">
                  {{ delivery.user.name }}
                </dd>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-4">
              <div
                v-for="delivery_process_attribute in deliveryAttributes"
                :key="delivery_process_attribute.id"
                class="sm:col-span-3"
              >
                <dt class="label-data">
                  {{ delivery_process_attribute.label }}
                </dt>
                <dd class="content-data">
                  {{
                    deliveryProcessValue(
                      delivery_process_attribute.id
                    )
                  }}
                </dd>
              </div>
            </div>

            <hr />

            <div class="panel">
              <div class="panel-header">
                <h3 class="panel-header-title">
                  {{ $t("labels.delivery_items") }}
                </h3>
              </div>
              <div class="panel-body">
                <div class="space-y-8 divide-y divide-gray-200">
                  <div
                    v-for="(delivery_item, index) in delivery.delivery_items"
                    class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                    :key="index"
                  >
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_item.delivery_product") }}
                      </dt>
                      <dd class="content-data">
                        {{ delivery_item.delivery_product.crop.name }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_item.quantity") }}
                      </dt>
                      <dd class="content-data">
                        {{ delivery_item.quantity }}
                        {{ delivery_item.delivery_product.unit_of_measure }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_item.unit_price") }}
                      </dt>
                      <dd class="content-data">
                        S/ {{ delivery_item.unit_price }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_item.total_price") }}
                      </dt>
                      <dd class="content-data">
                        S/ {{ delivery_item.total_price }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_item.order_item") }}
                      </dt>
                      <dd class="content-data">
                        {{ delivery_item.order_item.order.order_code }} -
                        {{
                          delivery_item.order_item.order
                            .delivery_process_customer.name
                        }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_item.delivery_collection_item") }}
                      </dt>
                      <dd class="content-data">
                        {{
                          delivery_item.delivery_collection_item
                            .delivery_collection.collection_code
                        }}
                        -
                        {{
                          delivery_item.delivery_collection_item
                            .delivery_process_provider.name
                        }}
                      </dd>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/show_delivery.js";
export default {
  name: "SPDeliveryDistributionShowDelivery",
  components: {},
  data() {
    return {
      load_general_data: false,
      delivery_process: {},
      delivery: {},
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
    id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.loadData())
    );
  },
  computed: {
    deliveryAttributes() {
      return this.delivery_process.delivery_process_attributes.filter(
        (attr) => attr.use_in_deliveries
      );
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchDeliveryProcess();
      await this.fetchDelivery();
      this.load_general_data = true;
    },

    fetchDeliveryProcess: async function () {
      const response = await Requester.fetchDeliveryProcess(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_process = response.data;
    },

    fetchDelivery: async function () {
      const response = await Requester.fetchDelivery(
        this.service_provider_id,
        this.delivery_process_id,
        this.id
      );

      this.delivery = response.data;
    },

    deliveryProcessValue(delivery_process_attribute_id) {
      return this.delivery.delivery_attribute_values?.find(
        (value) =>
          value.delivery_process_attribute_id === delivery_process_attribute_id
      )?.label_value || "";
    },
  },
  watch: {},
};
</script>
